import {
  ForgotPasswordPayload,
  ForgotPasswordResponse,
  SetPasswordPayload,
  SetPasswordResponse,
} from './interfaces';
import { usePost } from '@selfserve/react-hooks';

import { apiEndpoints } from '@selfserve/react-utils';

export const useForgotPasswordRequest = () =>
  usePost<ForgotPasswordPayload, ForgotPasswordResponse>(
    apiEndpoints.forgotPassword
  );

export const useSetPasswordRequest = () =>
  usePost<SetPasswordPayload, SetPasswordResponse>(apiEndpoints.setPassword);

export * from './interfaces';
export * from './schemas';
